import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap"; 
import axios from "../../API/axios";
import { post, people } from "../../config/imagesLink";
import { ShimmerThumbnail } from "react-shimmer-effects";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv } from "@skeleton";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";


const BlockedUser = () => {

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const language = localStorage.getItem("Lang");
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);
    const { t } = useTranslation();
    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const sessionId = localStorage.getItem("sessionId");
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [blockUser, setBlockUser] = useState([]);

      // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  
    const getblockeduser = () => {
        const data = {
            deviceType: "Web",
            sessionId,
            langKey: language === "en" ? "" : language,

        };
        axios
            .post(`User/GetUserBlockedUsers`, data)
            .then((response) => {
                console.log("people res", response.data.responseData);
                setIsLoading(false);
                {
                    response.data.responseData.length === 0 ? setIsError(true) :
                        setBlockUser(response.data.responseData)
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 404) {
                    setIsError(true);
                } else {
                    console.log(error);
                }
                setIsLoading(false);
            });
    };
    useEffect(() => {
        getblockeduser();
    }, []);


    //************************Block User  ************************//

    const unblockUser = async (id) => {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("UserUid", id);
        formData.append("Language",   language === "en" ? "" : language,);
        try {
            const res = await axios.post("User/UnBlockUser", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log('vashhgd', res);

            setToastMessage(res.data.message);
            setShowToast(true);
            getblockeduser()
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    //************************Block User  ************************//

    const handleProfileImageError = (e) => {
        if (!e || !e.target) return;
        e.target.onerror = null;
        e.target.src = people.DefaultProfile;
    };

    return (
        <>
            <div className='setting-header'>
                <h4> {t("User Profile.Blocked users")} </h4>
            </div>
            <div className="p-3 ">
                {isLoading ? (
                    <div className="mt-3">
                        <ShimmerDiv height={250} width={'100%'} />
                    </div>
                ) : isError ? (
                    <div className="mt-2 error-image-cont error-cont">
                        <img src={post.errorSmall} alt="404 Not Found" width={200} />
                    </div>
                ) : (
                    blockUser &&
                    blockUser?.map((item, index) => {
                        console.log('item2222222222', item);
                        return (
                            <div className="d-flex align-items-center mb-2">
                                <div className="image-conti me-2 ">
                                     <Link to={`/User/${item.userUid}`}>
                                      <img
                                        src={item?.profilPic || people.DefaultProfile}
                                        alt=""
                                        width={50}
                                        height={50}
                                        style={{ borderRadius: '50px', border: '1px solid' }}
                                        onError={handleProfileImageError}
                                      />
                                     </Link>
                                </div>
                                <div className="userName">
                                    <Link to={`/User/${item.userUid}`}>
                                       <h1>{item?.fullName}</h1>
                                    </Link>
                                </div>
                                <button
                                    className=" followStyle followBtn ms-auto"
                                    onClick={() => { unblockUser(item?.userUid) }}
                                >
                                    {t("Recommendations.Unblock")}
                                </button>
                            </div>

                        );
                    })
                )}
            </div>


            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default BlockedUser
